module.exports = __webpack_public_path__ + "static/img/ideaImg2.eb0d5f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/ideaImg2.png
// module id = l02d
// module chunks = 0